<script lang="ts">
	import MailIcon from "@lucide/svelte/icons/mail";
	import Section from "#lib/web-ui/primitives/section.svelte";
	import { getTemplateContext } from "../template-context.svelte";
	import { HOME_BUYERS_TEAM_PATH } from "@fergmar/ui/home-buyers/home-buyers-team";
	import type { TeamMember } from "../template-types";

	const templateContext = getTemplateContext();
</script>

{#snippet photo(teamMember: TeamMember)}
	<img
		src={teamMember.headshot}
		alt={teamMember.displayName}
		class="h-24 w-24 flex-shrink-0 rounded-full object-cover"
		width="96"
		height="96"
		loading="lazy"
	/>
{/snippet}

<Section>
	<div class="grid grid-cols-1 gap-12 lg:grid-cols-3">
		<div class="lg:col-span-1">
			<h2
				class="text-foreground text-3xl font-semibold tracking-tight text-pretty sm:text-4xl"
			>
				Meet the {templateContext.siteName} Team
			</h2>
			<p class="text-muted-foreground mt-6 text-lg/8 text-balance">
				{templateContext.siteName}, headquartered in Victoria, TX, is a family-owned company
				focused on eliminating the pain points traditionally associated with selling your
				house. We buy houses fast for cash in any condition throughout the Crossroads. Meet
				the people helping you sell your house quickly and hassle-free.
			</p>
		</div>

		<div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:col-span-2 lg:grid-cols-2">
			{#each templateContext.teamMembers as teamMember (teamMember.workEmail)}
				<div class="flex items-center gap-4" data-testid="team-card">
					{#if teamMember.hasPage}
						<a
							href="{HOME_BUYERS_TEAM_PATH}/{teamMember.slug}"
							class="flex-shrink-0 rounded-full"
							aria-label="Open the page of {teamMember.displayName}"
						>
							{@render photo(teamMember)}
						</a>
					{:else}
						{@render photo(teamMember)}
					{/if}
					<div class="flex min-w-0 flex-1 flex-col gap-1">
						<h3 class="text-foreground text-base font-semibold tracking-tight">
							{#if teamMember.hasPage}
								<a
									href="{HOME_BUYERS_TEAM_PATH}/{teamMember.slug}"
									class="hover:text-primary transition-colors"
								>
									{teamMember.displayName}
								</a>
							{:else}
								{teamMember.displayName}
							{/if}
						</h3>

						<p class="text-primary text-sm font-semibold">
							{teamMember.title}
						</p>
						{#if teamMember.workEmail}
							<a
								href="mailto:{teamMember.workEmail}"
								class="text-muted-foreground/70 hover:text-primary mt-0.5 transition-colors"
								aria-label="Email {teamMember.displayName}"
							>
								<MailIcon class="h-4 w-4" strokeWidth={2} />
							</a>
						{/if}
					</div>
				</div>
			{/each}
		</div>
	</div>
</Section>
